import axios from "axios";
import { config } from "../config";
import Call from "../utils/Call";
import storage from "../utils/Storage";

class EventApi extends Call {
    constructor() {
        super(config.EVENT_HOST);
    }

    header() {
        return {
            "Content-Type": "application/json",
            Authorization: `Bearer ${config.JWT_SECRET}`,
        };
    }

    async createEvent(data) {
        try {
            return await this.call("post", `/event`, { data });
        } catch (err) {
            return false;
        }
    }

    async getEvent(id) {
        try {
            return await this.call("get", `/event/${id}`, {});
        } catch (err) {
            return false;
        }
    }

    async listEvents() {
        try {
            return await this.call("get", `/event`, {});
        } catch (err) {
            return err;
        }
    }

    async confirmPerson(event_id, cpf) {
        try {
            return await this.call("get", `/event/${event_id}/${cpf}`, {});
        } catch (err) {
            return err;
        }
    }

    async confirmPersonByName(event_id, name) {
        try {
            return await this.call("get", `/event/${event_id}/name/${name}`, {});
        } catch (err) {
            return err;
        }
    }

    async getStatus() {
        try {
            return await this.call("get", `/status`, {});
        } catch (err) {
            return err;
        }
    }

    async createBulkPosition(data) {
        try {
            return await this.call("post", `/position/bulk`, { data });
        } catch (err) {
            return err;
        }
    }

    async getPositionByEvent(id) {
        try {
            return await this.call("get", `/position/event/${id}`, {});
        } catch (err) {
            return err;
        }
    }

    async getPositionById(id) {
        try {
            return await this.call("get", `/position/${id}`, {});
        } catch (err) {
            return err;
        }
    }

    async createPerson(data) {
        try {
            return await this.call("post", `/people`, { data });
        } catch (err) {
            return err;
        }
    }

    async updatePerson(id, data) {
        try {
            return await this.call("put", `/people/${id}`, { data });
        } catch (err) {
            return err;
        }
    }

    async updateStatusPerson(id, status) {
        try {
            return await this.call("put", `/people/${id}/${status}`, {});
        } catch (err) {
            return err;
        }
    }

    async getPersonByEvent(id, params) {
        try {
            return await this.call("get", `/people/event/${id}`, { params });
        } catch (err) {
            return err;
        }
    }

    async getAllPersonByEvent(id, params) {
        try {
            return await this.call("get", `/people/all/event/${id}`, { params });
        } catch (err) {
            return err;
        }
    }

    async deletePerson(id) {
        try {
            return await this.call("delete", `/people/${id}`, {});
        } catch (err) {
            return err;
        }
    }

    async getPeople() {
        try {
            return await this.call("get", `/people`, {});
        } catch (err) {
            return err;
        }
    }

    async searchPeople(params) {
        try {
            return await this.call("get", `/people/search`, { params });
        } catch (err) {
            return err;
        }
    }

    async getCategory() {
        try {
            return await this.call("get", `/category`, {});
        } catch (err) {
            return err;
        }
    }

    async getGrade() {
        try {
            return await this.call("get", `/grade`, {});
        } catch (err) {
            return err;
        }
    }

    async getPeopleByPosition(id, params) {
        try {
            return await this.call("get", `/position/event/${id}/search`, { params });
        } catch (err) {
            return err;
        }
    }

    async getPersonById(id) {
        try {
            return await this.call("get", `/people/${id}`, {});
        } catch (err) {
            return err;
        }
    }

    async sendInvitationMail(name, email, confirmUrl) {
        try {
            return await this.call("post", `/send/mail`, {
                data: {
                    type: "invite_mail",
                    confirm_url: confirmUrl,
                    name: name,
                    email: email,
                },
            });
        } catch (err) {
            return err;
        }
    }

    async sendConfirmationMail(name, email, qrcode) {
        try {
            return await this.call("post", `/send/mail`, {
                data: {
                    type: "confirmation_mail",
                    qrcode: qrcode,
                    name: name,
                    email: email,
                },
            });
        } catch (err) {
            return err;
        }
    }

    async sendNewMail(data) {
        try {
            return await this.call("post", `/send/mail`, { data });
        } catch (err) {
            return err;
        }
    }

    async createOutsideGuestAndConfirm(data) {
        try {
            return await this.call("post", `/people/confirm/inova`, { data });
        } catch (err) {
            return err;
        }
    }

    async uploadPhoto(eventId, personId, formData) {
        let head = this.header();
        head["Content-Type"] = `multipart/form-data; boundary=${formData._boundary}`;
        head["Access-Control-Allow-Origin"] = "*";
        try {
            return await axios.post(`${config.EVENT_HOST}/people/upload/${eventId}/${personId}`, formData, {
                headers: head,
            });
        } catch (err) {
            // if (err.response?.status === 401) {
            //     storage.remove("token");
            //     storage.remove("user");
            //     storage.remove("app-token");
            //     window.location.href = "/login";
            // }
            return err;
        }
    }

    async getPhoto(eventId, personId) {
        try {
            return await this.call("get", `/people/photo/${eventId}/${personId}`, {});
        } catch (err) {
            return err;
        }
    }

    async addPersonToActivity(data) {
        try {
            return await this.call("post", `/leads`, { data });
        } catch (err) {
            return err;
        }
    }

    async getActivities() {
        try {
            return await this.call("get", `/activities`, {});
        } catch (err) {
            return err;
        }
    }

    async getLeadsByActivity(activity_id) {
        try {
            return await this.call("get", `/leads/activitiy/${activity_id}`, {});
        } catch (err) {
            return err;
        }
    }

    async createActivity(data) {
        try {
            return await this.call("post", `/activities`, { data });
        } catch (err) {
            return err;
        }
    }

    async getPersonByDocOrEmail(params) {
        try {
            return await this.call("get", `/eduzz`, { params });
        } catch (err) {
            return err;
        }
    }

    async getPersonFromEduzzByDocOrEmail(event_id, params) {
        try {
            return await this.call("get", `/eduzz/all/event/${event_id}`, { params });
        } catch (err) {
            return err;
        }
    }

    async getActivity(id) {
        try {
            return await this.call("get", `/activities/${id}`, {});
        } catch (err) {
            return err;
        }
    }

    async createCredential(data) {
        try {
            return await this.call("post", `/credentials`, { data });
        } catch (err) {
            return err;
        }
    }

    async createAccessLog(data) {
        try {
            return await this.call("post", `/access/logs`, { data });
        } catch (err) {
            return err;
        }
    }

    async registerAccess(data) {
        try {
            return await this.call("post", `/access/register`, { data });
        } catch (err) {
            return err;
        }
    }

    async createMaterial(data) {
        try {
            return await this.call("post", `/materials`, { data });
        } catch (err) {
            return err;
        }
    }

    async associatePersonToMaterial(id, data) {
        try {
            return await this.call("post", `/materials/associate/${id}`, { data });
        } catch (err) {
            return err;
        }
    }

    async desassociatePersonFromMaterial(id) {
        try {
            return await this.call("put", `/materials/desassociate/${id}`, {});
        } catch (err) {
            return err;
        }
    }

    async getMaterial(id) {
        try {
            return await this.call("get", `/materials/${id}`, {});
        } catch (err) {
            return err;
        }
    }

    async listMaterials() {
        try {
            return await this.call("get", `/materials`, {});
        } catch (err) {
            return err;
        }
    }

    async listMaterialHistory(id) {
        try {
            return await this.call("get", `/materials/history/${id}`, {});
        } catch (err) {
            return err;
        }
    }

    async associateWithMultipleMaterials(data) {
        try {
            return await this.call("put", `/materials/associate/multiples`, { data });
        } catch (err) {
            return err;
        }
    }

    async updateMaterial(id, data) {
        try {
            return await this.call("put", `/materials/${id}`, { data });
        } catch (err) {
            return err;
        }
    }

    async deleteMaterial(id) {
        try {
            return await this.call("delete", `/materials/${id}`, {});
        } catch (err) {
            return err;
        }
    }
}

export default new EventApi();
